function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pm)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M226.231 322.798V264.872C226.231 258.17 224.267 251.614 220.582 246.016V246.016C215.154 237.771 206.74 231.953 197.109 229.786L196.532 229.656C196.532 229.656 194.973 253.039 220.305 256.156",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.231 330.592V272.664C226.231 265.962 228.195 259.406 231.88 253.808C237.308 245.562 245.723 239.743 255.355 237.577L255.932 237.447C255.932 237.447 257.491 260.831 232.159 263.947",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.582 246.013C215.154 237.767 206.74 231.949 197.109 229.782L196.532 229.653C196.532 229.653 199.997 253.941 225.332 257.059L226.232 322.798V264.872C226.232 258.169 224.268 251.612 220.582 246.013V246.013Z",
  fill: "#C6E647"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.93 237.447L255.353 237.577C245.722 239.744 237.308 245.562 231.88 253.807V253.807C228.195 259.405 226.231 265.961 226.231 272.663V330.591L227.672 262.827C253.004 259.71 255.93 237.447 255.93 237.447Z",
  fill: "#C6E647"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.231 318.767V285.121C226.231 281.228 225.091 277.42 222.95 274.168V274.168C219.798 269.379 214.911 265.999 209.318 264.74L208.983 264.665C208.983 264.665 208.077 278.247 222.791 280.058",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.719 315.033H206.741V409.101H245.719V315.033Z",
  fill: "#C6E647"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.17 298.013V395.413L60.742 409.256H104.815L119.086 272.791L67.17 298.013Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.962 156.109L145.383 152.143V409.261H99.13L104.816 399.072L76.962 156.109Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.315 34.519V43.659C80.3162 47.0916 81.4681 50.4248 83.5865 53.1258C85.7049 55.8268 88.6675 57.7398 92.001 58.559L106.546 62.137V26.408L94.454 23.436C92.7733 23.0224 91.0205 22.9965 89.3284 23.3603C87.6362 23.7241 86.0489 24.468 84.6867 25.5358C83.3245 26.6036 82.223 27.9672 81.4656 29.5236C80.7082 31.0799 80.3148 32.7881 80.315 34.519V34.519Z",
  fill: "#FFE1B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.315 43.657C80.3149 47.0907 81.4661 50.4252 83.5846 53.1275C85.7031 55.8297 88.6665 57.7435 92.001 58.563L106.546 62.141",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.131 41.8429C95.5181 41.8429 95.832 41.5291 95.832 41.1419C95.832 40.7548 95.5181 40.4409 95.131 40.4409C94.7438 40.4409 94.43 40.7548 94.43 41.1419C94.43 41.5291 94.7438 41.8429 95.131 41.8429Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.359 41.8429C84.7462 41.8429 85.06 41.5291 85.06 41.1419C85.06 40.7548 84.7462 40.4409 84.359 40.4409C83.9719 40.4409 83.658 40.7548 83.658 41.1419C83.658 41.5291 83.9719 41.8429 84.359 41.8429Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.515 45.3259V34.5189H82.101",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.452 34.5189H91.038",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.815 40.056V43.809C105.787 43.809 106.72 43.4227 107.407 42.7352C108.095 42.0477 108.481 41.1152 108.481 40.143C108.481 40.031 108.476 39.9196 108.466 39.809C108.26 37.534 104.815 37.771 104.815 40.056Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.815 43.8099C105.787 43.8099 106.72 43.4237 107.407 42.7362C108.095 42.0487 108.481 41.1162 108.481 40.1439",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.48 46.589C90.9353 47.0441 91.5527 47.2998 92.1965 47.2998C92.8402 47.2998 93.4577 47.0441 93.913 46.589",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.52 45.335L89.888 45.917",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.84 31.086C80.84 31.086 81.24 25.086 86.682 25.452C92.124 25.818 99.908 25.328 100.526 30.273C101.144 35.218 103.047 39.173 104.815 39.173",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.315 38.217C80.315 38.217 61.058 3.326 95.131 0.854002C129.204 -1.618 145.238 43.541 106.648 50.463",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.46 46.454C107.46 46.9771 107.305 47.4885 107.014 47.9234C106.724 48.3584 106.31 48.6974 105.827 48.8976C105.344 49.0978 104.812 49.1502 104.299 49.0481C103.786 48.9461 103.315 48.6942 102.945 48.3243C102.575 47.9543 102.323 47.4831 102.221 46.97C102.119 46.4569 102.171 45.9251 102.371 45.4418C102.572 44.9585 102.911 44.5454 103.346 44.2547C103.78 43.9641 104.292 43.809 104.815 43.809",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.315 48.485C79.9891 48.7579 79.6023 48.9481 79.1873 49.0398C78.7723 49.1314 78.3413 49.1217 77.9309 49.0115C77.5204 48.9012 77.1425 48.6937 76.8293 48.4064C76.5161 48.1192 76.2767 47.7607 76.1314 47.3613C75.9861 46.9619 75.9391 46.5333 75.9946 46.1119C76.05 45.6906 76.2062 45.2888 76.4499 44.9405C76.6936 44.5923 77.0175 44.3079 77.3944 44.1115C77.7713 43.9151 78.19 43.8123 78.615 43.812",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.382 100.05V157.323L64.248 177.264V113.478C64.2477 102.488 67.9321 91.8156 74.7121 83.1664C81.492 74.5173 90.9761 68.391 101.648 65.767V65.767C106.846 64.4885 112.268 64.4092 117.501 65.535C122.735 66.6608 127.644 68.9622 131.857 72.265C136.07 75.5679 139.477 79.7858 141.819 84.5995C144.162 89.4132 145.379 94.6966 145.378 100.05H145.382Z",
  fill: "#FA7F58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.382 157.319L64.248 177.26V302.71L187.555 283.291L145.382 157.319Z",
  fill: "#FFC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.13 409.261L104.816 399.072L89.146 262.39",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.747 73.861C133.747 73.861 172.486 107.327 147.105 154.134C121.724 200.941 39.976 134.024 38.984 128.749C37.992 123.474 46.566 122.157 53.817 126.112C53.817 126.112 52.828 120.712 56.784 122.259C60.74 123.806 62.717 128.419 62.717 128.419L118.424 130.726L111.169 100.071",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.263 129.187L56.787 64.729L0.75 79.964L35.361 157.322L66.327 151.047",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.257 156.428C75.257 156.428 106.514 196.97 152.726 179.258L145.231 157.234C130.183 179.623 99.717 170.227 75.257 156.428Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.84 76.665L66.289 89.753",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.022 109.629C14.022 109.629 4.87001 143.995 26.622 158.581C48.374 173.167 64.248 162.285 64.248 162.285",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pm"
}, /*#__PURE__*/React.createElement("rect", {
  width: 256.728,
  height: 410.282,
  fill: "white"
})));

var SvgPaperMa = function SvgPaperMa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 411,
    viewBox: "0 0 257 411",
    fill: "none",
    className: "hidden md:block absolute bottom-0 right-0 mr-40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperMa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PaperMa.1d802cc6.svg";
export { ForwardRef as ReactComponent };